import TopBar from "@/pages/home/components/TopBar";
import HeroSection from "@/pages/home/components/HeroSection";
import HotTicker from "@/pages/home/components/HotTicker";
import HotKeywordIndex from "@/pages/home/components/HotKeywordIndex";
import RankBoard from "@/pages/home/components/RankBoard";
import FeatureCollections from "@/pages/home/components/FeatureCollections";
import PersonSearch from "@/pages/home/components/PersonSearch";
import IndexZones from "@/pages/home/components/IndexZones";
import LatestFeed from "@/pages/home/components/LatestFeed";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopBar />
      <main className="flex-1">
        <HeroSection />
        <HotTicker />
        <HotKeywordIndex />
        <RankBoard />
        <FeatureCollections />
        <PersonSearch />
        <IndexZones />
        <LatestFeed />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}